/** Text with its line breaks kept (D-13-L-18: the registers hold plain text; the record page shows its lines). */
import { Fragment } from 'react';

export default function Lines({ text }: { text: string }) {
  const lines = text.split('\n');
  return (
    <>
      {lines.map((line, i) => (
        <Fragment key={i}>
          {i > 0 && <br />}
          {line}
        </Fragment>
      ))}
    </>
  );
}
